const DiagramTreeStyle = Object.freeze({
  Layered: 40,
  LastParents: 41,
  Alternating: 42,
  RootOnly: 43,
});

export default DiagramTreeStyle;
